export default {
  page_title: 'About',
  t_whatis: "What is HKLII?",
  t_personnel: 'Personnel',
  t_assist: 'Assistance to HKLII',
  intro: [
    "The {0} (HKLII - pronounced 'H K Lee') is a free access legal information system developed and jointly operated by the University of Hong Kong {1} and {2}, with the kind assistance of the Australasian Legal Information Institute ({3}).",
    "HKLII's mission is to provide free access to primary legal materials from Hong Kong (and some publicly available secondary materials) by use of technology that is both easy to use and powerful in the diversity of materials that it covers.",
    'The system is based on data obtained from sources in Hong Kong and the region. Mark-up, processing, database structure, search engine facilities, and some other aspects of technical infrastructure are adapted from software provided by AustLII. The Hong Kong, China and Taiwan pages (and some subject pages) of the World Law index are jointly prepared by HKU Faculty of Law and AustLII. The overall facility is managed by Faculty of Law.',
    'We hope that you enjoy using HKLII and find it to be a useful service. Any words of encouragement or constructive criticism are always welcome of course.'
  ],
  cs_dept: 'Department of Computer Science',
  law_fac: 'Faculty of Law',
  law_fac2: 'Faculty of Law',
  addr_tag: 'Mail address',
  addr: 'HKLII Team<br>10/F, Cheng Yu Tung Tower<br>Centennial Campus<br>The University of Hong Kong<br>Pokfulam Road<br>HONG KONG<br>',
  email_tag: 'E-mail',
  email: 'Please direct your correspondence to {0}',
  website_tag: 'Website',
  personnel: [
    'HKLII is a project of {0}, a centre jointly established by {1} and {2} of the {3}. HKLII has obtained the kind assistance of the {4} in its development.',
    'Please direct all enquiries or feedback using the {0} page.'
  ],
  law_and_tech: 'Law & Technology Centre',
  uni: 'University of Hong Kong',
  management_tag: 'Management',
  staff_tag: 'Staff',
  former_staff_tag: 'Former Staff',
  providers_tag: 'Data Providers',
  providers: [
    'HKLII has been assisted by the provision of data from the following sources for inclusion in HKLII databases:',
    'HKLII wishes to express its appreciation to all of its data  providers. Further acknowledment is provided on the front pages of each database.'
  ],
  provider_ents: [
    'The Judiciary of the Hong Kong Special Administrative Region (HKSAR)',
    'The Department of Justice, HKSAR',
    'The Hong Kong International Arbitration Centre (HKIAC)',
    'The Law Library of the University of Hong Kong Libraries',
    'The Centre for Comparative and Public Law, Faculty of Law, University of Hong Kong'
  ],
  grants_tag: 'Grants',
  grants: [
    'The establishment and initial maintenance of HKLII is supported by the University of Hong Kong Department of Computer Science and Faculty of Law, with the kind assistance of the Australasian Legal Information Institute (AustLII) from grants received by AustLII for the provision of better access to common law and Asia-Pacific regional legal information.',
    'Enquiries concerning sponsorship of HKLII and resources on HKLII are welcome. Please see the {0} and {1} section for contact details.',
  ],
  thanks_tag: 'Thanks to...',
  thanks: [
    'The establishment of HKLII has been assisted by many individuals, and particularly by many individual officers of the Judiciary of the HKSAR and the Department of Justice of HKSAR. They are too numerous to list, but HKLII wishes to thank them for their assistance and support.'
  ]
}